import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { CUSTOMER_ADDRESS_API } from '@shared/constants/api.constants';
import { CustomerAddressSearch } from '@shared/models/customer-address/customer-address.model';
import { Observable } from 'rxjs';
import { CustomerAddressPayload } from '@shared/models/customer-address/customer-address.model';

@Injectable({
  providedIn: 'root'
})
export class CustomerAddressService {

  constructor(
    private http: HttpService
  ) { }

  getCustomerAddresses(payload: CustomerAddressPayload) : Observable<CustomerAddressSearch>{
    return this.http.post(CUSTOMER_ADDRESS_API.SEARCH, payload)
  }
}
